export const getItems = async (param, getRateChangeHistory) => {
  await getRateChangeHistory(param)
    .then((res) => {
      console.log("history  rate  ", res);
    })
    .catch((err) => {
      console.log("err ", err);
    });
};
